import gql from 'graphql-tag';

import type { FeedAssetGroup } from 'src/data/project';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationApplyFormatToAssetGroupArgs } from 'src/types/backend';

import { FRAGMENT_ASSET_GROUP } from './schema';

const MUTATION = gql`
  mutation ApplyFormatToAssetGroup($assetGroupId: ID!) {
    applyFormatToAssetGroup(assetGroupId: $assetGroupId) {
      ...AssetGroupFields
    }
  }
  ${FRAGMENT_ASSET_GROUP}
`;

/**
 * Applies the AP style fix prepared for each part to the whole card, in place. A part with no fix
 * ready keeps its text.
 */
export const applyFormatToAssetGroup = async (
  variables: BackendMutationApplyFormatToAssetGroupArgs
): Promise<FeedAssetGroup | undefined> => {
  const response = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<FeedAssetGroup>(response.data);
};
